//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { axiosPost } from '../../axios/axios.js'
import { api as fullscreen } from 'vue-fullscreen'
import MessengerCodeDialog from './MessengerCodeDialog.vue'

export default {
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      userImg: null,
      fullscreen: fullscreen
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      hasFaulties: 'getHasFaulties'
    }),
    displayUserPopupFullMenu: function () {
      return this.user.hasUIAccess('displayUserPopupFullMenu')
    }
  },
  created: function () {
    this.prepareImg()
  },
  methods: {
    prepareImg: function () {
      if (this.user.employee && this.user.employee.imageId) {
        this.userImg = '/service/fileobj/read/' + this.user.employee.imageId
      }
    },
    onOpenSettings: function () {
      this.openedPopup = false
    },
    onClickMessengerCode: function () {
      this.$d.dialog(this).show({
        persistent: true,
        headerLabel: 'Код авторизации мессенджера',
        contentComponent: MessengerCodeDialog
      })
    },
    onExit: function () {
      this.$d_ask((data, action) => {
        if (action === 'yes') {
          this.exitApp()
        }
      }, 'Вы действительно хотите выйти?', {}, {
        yes: 'Да',
        no: 'Нет'
      })
    },
    exitApp: function () {
      axiosPost({
        url: '/logout',
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          const redirectURL = new URL(window.location.href)
          redirectURL.pathname = '/logout'
          window.location.href = redirectURL.href
        },
        onFailure: 'Ошибка выхода из системы',
        msgTarget: this
      })
    }
  }
}
